import React, { Component } from "react";
import FlexText from "../../flexText";

class OverlayTop extends Component {
  render() {
    //console.log("-->",this.props.blockStyle)
    return (
      <div
        className="overlayTop"
        style={{
          ...this.props.style,
          backgroundColor: this.props.blockStyle.attributes.field_color_1
        }}
      >
        <FlexText
          max="32"
          min="32"
          pert=".25"
          classes="flexText"
          tag="h2"
          color={
            this.props.blockStyle.attributes.field_title_color_font[0]
              .field_color_1
          }
          styles={{
            fontFamily: this.props.blockStyle.attributes
              .field_heading_color_font[0].field_font_1.name,
            fontSize: "32px",
            textAlign: "left",
            display: "block",
            width: "100%",
            lineHeight: "40px"
          }}
        >
          {this.props.data[0].field_text_1}
        </FlexText>
        <FlexText
          max="16"
          min="16"
          pert=".25"
          classes="flexText"
          tag="div"
          color={
            this.props.blockStyle.attributes.field_text_color_font[0]
              .field_color_1
          }
          styles={{
            fontFamily: this.props.blockStyle.attributes
              .field_text_color_font[0].field_font_1.name
          }}
        >
          {this.props.data[0].field_longtext_1}
        </FlexText>
      </div>
    );
  }
}

export default OverlayTop;
